import styled from 'styled-components';
import { Colors } from 'modules/theme';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const BarShell = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 6px 12px 6px 40px;
  min-height: 40px;
  border: 1px solid ${props => (props.focused ? Colors.lightBlue : Colors.gray2)};
  box-shadow: ${props => (props.focused ? '0 0 0 3px rgba(20, 152, 203, 0.12)' : 'none')};
  border-radius: 20px;
  background: ${Colors.white};
  transition: border-color 120ms ease, box-shadow 120ms ease;
  position: relative;
`;

export const SearchIcon = styled.i`
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: ${Colors.lightBlue};
  font-size: 14px;
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${Colors.ligthDarkBlue};
  color: ${Colors.darkBlue};
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  padding: 5px 8px 5px 10px;
  border-radius: 14px;
  max-width: 220px;
`;

export const ChipLabel = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ChipClose = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${Colors.darkBlue};
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 11px;
  line-height: 1;
  :hover {
    background: rgba(49, 70, 131, 0.15);
  }
`;

export const Input = styled.input`
  flex: 1 1 160px;
  min-width: 120px;
  border: none;
  outline: none;
  background: transparent;
  padding: 4px 2px;
  font-size: 14px;
  color: ${Colors.black2};
  ::placeholder {
    color: ${Colors.gray};
  }
`;

export const PanelContainer = styled.div`
  position: fixed;
  z-index: 1100;
  background: ${Colors.white};
  border: 1px solid ${Colors.gray2};
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  max-height: 380px;
  display: flex;
  flex-direction: column;
`;

export const PanelScroll = styled.div`
  overflow-y: auto;
  max-height: 380px;
`;

export const GroupHeader = styled.div`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${Colors.gray};
  padding: 8px 12px 4px;
  background: ${Colors.lightGray};
  border-top: 1px solid ${Colors.gray2};
  :first-child {
    border-top: none;
  }
`;

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  background: ${props => (props.active ? Colors.lightGray : 'transparent')};
  border-left: 3px solid ${props => (props.active ? Colors.lightBlue : 'transparent')};
  :hover {
    background: ${Colors.lightGray};
  }
`;

export const OptionIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${props => props.bg || Colors.gray2};
  color: ${Colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  flex-shrink: 0;
`;

export const OptionTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const OptionLabel = styled.span`
  font-size: 14px;
  color: ${Colors.black2};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const OptionSubtitle = styled.span`
  font-size: 12px;
  color: ${Colors.gray};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EmptyState = styled.div`
  padding: 16px 12px;
  color: ${Colors.gray};
  font-size: 13px;
  text-align: center;
`;

export const FooterHint = styled.div`
  border-top: 1px solid ${Colors.gray2};
  padding: 6px 12px;
  background: ${Colors.lightGray};
  font-size: 11px;
  color: ${Colors.gray};
  display: flex;
  justify-content: space-between;
`;
